import { PropsWithChildren } from 'react';

import { Box, BoxProps, useTheme } from '@material-ui/core';

export const FormFieldsBox = ({
  spacing = 3,
  children,
  ...boxProps
}: PropsWithChildren<{ spacing?: number } & BoxProps>) => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      gridGap={theme.spacing(spacing)}
      {...boxProps}
    >
      {children}
    </Box>
  );
};
